// vuex-persistedstate key for the logged-in session. The Engineering workspace
// (src/engineering) reads the token from here, so keep the two in sync by importing this.
const STORAGE_HASH = 'Ax4XDbqIDE'
export const STORAGE_KEY = `NCE Go-${STORAGE_HASH}`
